import { ref } from 'vue'
import { getVipList } from '@/api/member/vip'

let cachedVipOptions = null
let inflight = null

function normalizeVipOptions(list) {
  if (!Array.isArray(list)) return []

  const mapped = list
    .map(item => {
      const valueRaw = item?.value ?? item?.vip_level ?? item?.level ?? item?.vipLevel ?? item?.vip ?? item?.id
      const value = Number(valueRaw)
      if (Number.isNaN(value)) return null

      const labelRaw = item?.label ?? item?.name ?? item?.vip_name ?? item?.vipName ?? `VIP${value}`
      const label = String(labelRaw)

      return { label, value }
    })
    .filter(Boolean)

  mapped.sort((a, b) => a.value - b.value)
  return mapped
}

async function fetchVipOptions() {
  const res = await getVipList({
    page: 1,
    page_size: 100,
  })
  const raw = (res && res.data) || res
  const data = raw?.data != null ? raw.data : raw
  const list = data?.list ?? data?.items ?? data?.vip_list ?? data

  const normalized = normalizeVipOptions(list)
  if (normalized.length > 0) return normalized

  return Array.from({ length: 11 }, (_, i) => ({ label: `VIP${i}`, value: i }))
}

export function useVipOptions() {
  const vipOptions = ref(cachedVipOptions || [])
  const loading = ref(false)

  async function refresh() {
    loading.value = true
    try {
      inflight = inflight || fetchVipOptions()
      const options = await inflight
      cachedVipOptions = options
      vipOptions.value = options
      return options
    } finally {
      inflight = null
      loading.value = false
    }
  }

  if (!cachedVipOptions && !inflight) {
    refresh()
  }

  return { vipOptions, loading, refresh }
}
